<template>
    <user-layout
        hasBack
        backLink="/office/index"
    >
        <div class="max-w-[500px] mx-auto py-6" v-if="loaded">
            <form-section
                :form="form"
                :errors="errors"
                :regionOptions="regionOptions"
                :provinceOptions="provinceOptions"
                :cityOptions="cityOptions"
                :barangayOptions="barangayOptions"
                @update:location="init()"
            >
                <div class="col-span-2">
                    <div class="flex items-center justify-end w-full space-x-3">
                        <a href="/office/index/">
                            <button-component
                                btnWidth="quinary"
                            >Cancel</button-component>
                        </a>

                        <button-component
                            btnWidth="primary"
                            @click="showConfirmation = true"
                        >Save Changes</button-component>
                    </div>
                    <confirmation-modal
                        :typeTwo="true"
                        :show="showConfirmation"
                        @cancel="showConfirmation = false"
                        @confirm="save()"
                        cancel-text="Cancel"
                        action-text="Confirm"
                        title="Save Record"
                        content="Are you sure you wish to save this record?"
                    />
                    <success-modal
                        :show="showSuccess"
                        @confirm="showSuccess = false, $router.replace('/office/index')"
                        action-text="Close"
                        title="Succes!"
                       :content="successMessage"
                    />
                </div>
            </form-section>
        </div>
        <error-modal :show="showError" :content="showErrorMessage" />
        <page-loader :show="loading"/>
    </user-layout>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue';
import UserLayout from '@/layouts/UserLayout.vue';
import FormSection from './FormSection.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import PageLoader from "@/components/loaders/PageLoader.vue"
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';
import ErrorModal from "@/components/modals/ErrorModal.vue";
import { errorResponse } from "@/helpers/errorMessage";

import Offices from "@/classes/Offices";
import {
    OfficeDataInterface,
    SelectInterface
} from "@/interfaces/pages/offices/OfficeInterface"

import pickBy from "lodash/pickBy";

const loading = ref<boolean>(false);
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const loaded = ref<boolean>(false);
const successMessage = ref<string>('');
const errors = ref<any>();
const showError = ref(false);
const showErrorMessage = ref(null);

const form = ref<OfficeDataInterface>({
    name: '',
    logo: '',
    prefix: '',
    contact_number: '',
    address: '',
    region_id: 0,
    province_id: 0,
    city_id: 0,
    barangay_id: 0,
    status: 1,
    encoded_by: 0,
    iso: ''
});

const regionOptions = ref<SelectInterface[]>([]);
const provinceOptions = ref<SelectInterface[]>([]);
const cityOptions = ref<SelectInterface[]>([]);
const barangayOptions = ref<SelectInterface[]>([]);

const init = (): void => {
    loading.value = true; 

    Offices.create(pickBy(form.value))
        .then(({ data }) => { 
            loading.value = false;
            regionOptions.value = data.region;
            provinceOptions.value = data.province;
            cityOptions.value = data.city;
            barangayOptions.value = data.barangay;
            loaded.value = true;
        })
}

const save = (): void => {
    showError.value = false
    showErrorMessage.value = null;
    loading.value = true; 

    Offices.store(form.value)
        .then((response: any) => {
            loading.value = false;
            successMessage.value = response.data.message;
            showSuccess.value = true;
            showConfirmation.value = false            
        })
        .catch((error: any) => {
            loading.value = false;
            showConfirmation.value = false
            errors.value = errorResponse(error.response?.data?.errors)
            showError.value = true;
            showErrorMessage.value = 'Please fill up all required fields/Error Saving';
        });
}

onMounted(() => {
    init()
});

</script>